import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ChargeType SetFilter] Action',
  ResetFilter: '[ChargeType ResetFilter] Action',
}

const initialChargeTypeState: IChargeTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IChargeTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ChargeType', whitelist: ['filter']},
  (
    state: IChargeTypeState = initialChargeTypeState,
    action: ActionWithPayload<IChargeTypeState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialChargeTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
